import styled from 'styled-components';

const ClientActivityWrapper = styled.div`
  .box {
    height: 100%;
  }
`;

export { ClientActivityWrapper };
